import {createFileRoute, Outlet} from '@tanstack/react-router';
import {isPaymentMode} from 'features/shared/payment/types/PaymentMode';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/callback/_statuses',
)({
  validateSearch: (search) => {
    return {
      paymentId: `${search.paymentId}`,
      paymentMode: isPaymentMode(search.paymentMode)
        ? search.paymentMode
        : 'openbanking_sessionless',
    } as const;
  },
  component: Outlet,
});
